import { callApi } from '../../libs'

const getOrderData = async (orderNumber) => {
    return new Promise(async (resolve, reject) => {
        const url = `${process.env.REACT_APP_API_COVID19}/api/orders/get-by-order-number/${orderNumber}`
        const method = 'get'
        try {
            const response = await callApi(method, url, null, null)
            resolve(response)
        } catch (error) {
            reject(error)
        }
    })
}

export default getOrderData
